function Loader(){
    return(
        <section>
            <div className='flex justify-center my-10 '>
               <i className="fas animate-spin text-5xl text-red-800 font-bold fa-spinner"></i>
            </div>
        </section>
    )
}

export default Loader